import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, Button as MUIButton, } from "@mui/material";
import { convertPxToRem } from "../../util-functions";
import { Icon } from "../Icon";
// This contains the global styling for all button variations to build on
const StyledButton = styled(MUIButton, {
    shouldForwardProp: (prop) => prop !== "small",
})(({ theme, small, startIcon: icon }) => (Object.assign(Object.assign({ height: small ? convertPxToRem(32) : convertPxToRem(40), padding: small
        ? icon
            ? // small + icon variant
                `${convertPxToRem(8)} ${convertPxToRem(12)} ${convertPxToRem(8)} ${convertPxToRem(8)}`
            : // small variant
                `${convertPxToRem(8)} ${convertPxToRem(12)}`
        : icon
            ? // standard + icon variant
                `${convertPxToRem(8)} ${convertPxToRem(20)} ${convertPxToRem(8)} ${convertPxToRem(16)}`
            : // standard variant
                `${convertPxToRem(8)} ${convertPxToRem(20)}`, borderRadius: small ? convertPxToRem(12) : convertPxToRem(16), color: theme.palette.primaryBlackText.main }, (small
    ? theme.typography.smallTextStrong
    : theme.typography.largeTextStrong)), { transition: `all 0.2s`, "&:active": {
        transform: `scale(0.98)`,
    }, "&:disabled": {
        color: theme.palette.disabledText.main,
        backgroundColor: theme.palette.grey03.main,
    }, "&.Mui-focusVisible": {
        border: `${convertPxToRem(2.5)} solid ${theme.palette.primaryBlack.main}`,
    }, "& .MuiButton-startIcon": {
        marginRight: convertPxToRem(4),
    } })));
// styles for primary button variant--this is the default button variant
const StyledPrimaryButton = styled(StyledButton)(({ theme }) => ({
    backgroundColor: theme.palette.sativaGreen.main,
    "&:hover": {
        backgroundColor: theme.palette.green06.main,
    },
}));
// styles for secondary button variant
const StyledSecondaryButton = styled(StyledButton)(({ theme }) => ({
    backgroundColor: theme.palette.primaryWhite.main,
    border: `${convertPxToRem(1)} solid ${theme.palette.green10.main}`,
    color: theme.palette.green10.main,
    "&:hover": {
        backgroundColor: theme.palette.green03.main,
        border: `${convertPxToRem(1)} solid ${theme.palette.green03.main}`,
    },
    "&:disabled": {
        backgroundColor: theme.palette.primaryWhite.main,
        border: `${convertPxToRem(1)} solid ${theme.palette.grey04.main}`,
    },
}));
// styles for state button variant
const StyledStateButton = styled(StyledButton)(({ theme }) => ({
    backgroundColor: theme.palette.midribGreen.main,
    color: theme.palette.primaryBlackText.main,
    "&:hover": {
        backgroundColor: theme.palette.sativaGreen.main,
    },
}));
// styles for filter button variant
const StyledFilterButton = styled(StyledButton)(({ theme }) => ({
    backgroundColor: theme.palette.grey03.main,
    color: theme.palette.primaryBlackText.main,
    "&:hover": {
        backgroundColor: theme.palette.grey04.main,
    },
}));
// styles for text button variant
const StyledTextButton = styled(StyledButton, {
    shouldForwardProp: (prop) => prop !== "small",
})(({ theme, small, startIcon: icon }) => ({
    backgroundColor: "none",
    border: "none",
    color: theme.palette.green10.main,
    padding: small
        ? icon
            ? // small + icon variant
                `${convertPxToRem(8)} ${convertPxToRem(6)} ${convertPxToRem(8)} ${convertPxToRem(2)}`
            : // small variant
                `${convertPxToRem(8)} ${convertPxToRem(6)}`
        : icon
            ? // standard + icon variant
                `${convertPxToRem(8)}${convertPxToRem(10)} ${convertPxToRem(8)}${convertPxToRem(4)}`
            : // standard variant
                `${convertPxToRem(8)} ${convertPxToRem(10)}`,
    "&:hover": {
        backgroundColor: theme.palette.green03.main,
    },
    "&:disabled": {
        backgroundColor: theme.palette.primaryWhite.main,
    },
}));
export const Button = ({ disabled = false, iconName, label, onClick, small = false, variant = "primary", testId, }) => {
    const enabledIconColor = variant === "secondary" || variant === "text"
        ? "green10"
        : "primaryBlackText";
    return (_jsxs(_Fragment, { children: [variant === "primary" && (_jsx(StyledPrimaryButton, Object.assign({ "data-testid": testId, small: small, onClick: onClick, disabled: disabled, startIcon: iconName && (_jsx(Icon, { iconName: iconName, fontSize: small ? "small" : "medium", color: disabled ? "disabledText" : enabledIconColor })), disableRipple: true }, { children: label }))), variant === "secondary" && (_jsx(StyledSecondaryButton, Object.assign({ "data-testid": testId, small: small, onClick: onClick, disabled: disabled, startIcon: iconName && (_jsx(Icon, { iconName: iconName, fontSize: small ? "small" : "medium", color: disabled ? "disabledText" : enabledIconColor })), disableRipple: true }, { children: label }))), variant === "state" && (_jsx(StyledStateButton, Object.assign({ "data-testid": testId, small: small, onClick: onClick, disabled: disabled, startIcon: iconName && (_jsx(Icon, { iconName: iconName, fontSize: small ? "small" : "medium", color: disabled ? "disabledText" : enabledIconColor })), disableRipple: true }, { children: label }))), variant === "filter" && (_jsx(StyledFilterButton, Object.assign({ "data-testid": testId, small: false, onClick: onClick, disabled: disabled, startIcon: iconName && (_jsx(Icon, { iconName: iconName, fontSize: small ? "small" : "medium", color: disabled ? "disabledText" : enabledIconColor })), disableRipple: true }, { children: label }))), variant === "text" && (_jsx(StyledTextButton, Object.assign({ "data-testid": testId, small: small, onClick: onClick, disabled: disabled, startIcon: iconName && (_jsx(Icon, { iconName: iconName, fontSize: small ? "small" : "medium", color: disabled ? "disabledText" : enabledIconColor })), disableRipple: true }, { children: _jsx("p", { children: label }) })))] }));
};
